import React from 'react';
import { motion } from 'framer-motion';
export function CaseStudy() {
  return <section id="proof" className="py-24 border-b border-stone-300" data-id="element-854">
      <div className="max-w-6xl mx-auto px-6" data-id="element-855">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-856">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-857">
            Proof Point
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-6 max-w-3xl" data-id="element-858">
            The Moon Palace playbook
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed mb-16 max-w-2xl" data-id="element-859">
            Moon Palace / Palace Resorts built an internal instant quoting
            portal. The results transformed their group segment economics.
            BlockQuote packages this proven playbook for every resort group.
          </p>

          {/* Metrics Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-stone-300 mb-24" data-id="element-860">
            <div className="p-8 border-b md:border-b lg:border-b-0 md:border-r border-stone-300" data-id="element-861">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-862">
                Wholesale Leakage Reduced
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-863">
                15–25<span className="text-red-600" data-id="element-864">%</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-865">
                Estimated leakage shifted to direct (management estimate)
              </p>
            </div>

            <div className="p-8 border-b md:border-b lg:border-b-0 lg:border-r border-stone-300" data-id="element-866">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-867">
                Estimated Annual Savings
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-868">
                $6.0M<span className="text-red-600" data-id="element-869">+</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-870">
                Per resort group at base case adoption (estimate)
              </p>
            </div>

            <div className="p-8 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-871">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-872">
                Quoting Velocity
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-873">
                &lt;1<span className="text-sm ml-1" data-id="element-874">min</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-875">Down from 48–72 hours</p>
            </div>

            <div className="p-8" data-id="element-876">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-877">
                Conversion Lift
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-878">
                ↑<span className="text-red-600" data-id="element-879">Higher</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-880">
                Speed wins group business
              </p>
            </div>
          </div>

          {/* DestaWed Story */}
          <div className="bg-stone-100 border border-stone-300 p-8 md:p-12" data-id="element-881">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-882">
              <div data-id="element-883">
                <div className="inline-block px-3 py-1 bg-red-600 text-white font-mono text-xs uppercase tracking-widest mb-6" data-id="element-884">
                  BlockQuote Investor
                </div>
                <h3 className="font-serif text-3xl text-stone-900 mb-4" data-id="element-885">
                  DestaWed: From Agency to Industry Leader
                </h3>
                <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-886">
                  DestaWed used BlockQuote's instant quoting infrastructure to
                  become the largest agency on record for Moon Palace resort
                  group. Their ability to quote instantly, hold inventory, and
                  present professional proposals gave them a massive competitive
                  advantage.
                </p>
                <blockquote className="border-l-2 border-red-600 pl-6 italic text-stone-700" data-id="element-887">
                  "BlockQuote fundamentally changed how we sell. We don't wait
                  days for pricing anymore — we close the group while they're
                  still excited on the first call."
                </blockquote>
              </div>

              <div className="grid grid-cols-2 gap-px bg-stone-300 border border-stone-300" data-id="element-888">
                <div className="bg-stone-50 p-6" data-id="element-889">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-890">
                    Status
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-891">
                    #1 Agency
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-892">
                    Largest on record for Moon Palace
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-893">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-894">
                    Volume
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-895">
                    3x Growth
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-896">
                    Group bookings volume increase
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-897">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-898">
                    Partnership
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-899">
                    Investor
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-900">
                    Strategic investor in BlockQuote
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-901">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-902">
                    Speed
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-903">
                    &lt;2 min
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-904">
                    Average quote-to-proposal time
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Source citation */}
          <p className="font-mono text-xs text-stone-400 mt-6" data-id="element-905">
            Source: Internal case study / management estimates
          </p>
        </motion.div>
      </div>
    </section>;
}